package com.appcreator.client.firebase.auth

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthDeleteUserAction
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseAuthRecentLoginRequiredException
import dev.gitlive.firebase.auth.FirebaseUser
import dev.gitlive.firebase.auth.auth


class DeleteUserPerformer(private val action: FirebaseAuthDeleteUserAction): Performer {
    @Composable
    override fun deferred(): Performer.Deferred {

        val reauthenticater = Reauthenticater(action.configureAppCheck)

        return object : Performer.Deferred {
            override suspend fun perform(envStore: EnvStore) {
                Firebase.auth.currentUser?.let {
                    try {
                        it.delete()
                    } catch (_: FirebaseAuthRecentLoginRequiredException) {
                        reauthenticater.perform(envStore)
                        Firebase.auth.currentUser!!.delete()
                    }
                    platformPreDelete(it)
                    Container.sendEvent(LoginEvent(null, null, null))
                }
            }
        }
    }
}

internal expect suspend fun platformPreDelete(user: FirebaseUser)